/* eslint-disable */
<template>
  <div id="instructor-table-container">
    <InstructorTableToolbar></InstructorTableToolbar>
    <InstructorDynamicTable></InstructorDynamicTable>
    <InstructorTablePagination></InstructorTablePagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InstructorDynamicTable from './InstructorTableDynamicComponent';
import InstructorTableToolbar from './InstructorTableToolbar';
import InstructorTablePagination from './InstructorTablePagination';
export default {
  name: 'table-container',
  components: {
    InstructorDynamicTable,
    InstructorTablePagination,
    InstructorTableToolbar,
  },
  data() {
    return {
    };
  },
  computed: {
  ...mapGetters([
    'activeView'
  ]),
  ...mapGetters('instructors', [
    'activeViewInstructor',
  ]),
  },
  methods: {
  ...mapActions('instructors', [
    'getTags',
  ])
  },
  async created() {
    // Fetch the tag data, allowing the user to click the tag chip on the bulb to filter data. This is also possible with
    // the filterMenu popover.
    await this.getTags({isSearch: true});
  },
};
</script>

<style scoped>
#instructor-table-container {
  width: 100%;
  height: 100%;
}
</style>
